import styled, { css } from 'styled-components';
import { Row as AntdRow, Col as AntdCol } from 'antd';
import { Form as FormikForm } from 'formik';

export const Wrapper = styled.section`
  ${({ theme }) => css`
    background-color: ${theme.colors.neutralSilver5};
    padding: 80px 24px;

    @media (max-width: 992px) {
      padding-top: 36px;
      padding-bottom: 64px;
    }
  `}
`;

export const Container = styled.div`
  max-width: 1320px;
  margin: 0 auto;
`;

export const Row = styled(AntdRow)`
  gap: 2.5rem;
`;

export const Col = styled(AntdCol)`
  max-width: none;
  flex-grow: 1;
`;

export const Form = styled(FormikForm)`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const FieldsWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 24px;

  > div {
    flex: 1;
  }

  @media (max-width: 365px) {
    flex-direction: column;
    gap: 20px;
  }
`;

export const FormTitle = styled.h2`
  ${({ theme }) => css`
    font-size: 1.8rem;
    font-weight: 600;
    color: ${theme.colors.neutralSilver90};
    line-height: 1.6;
    margin-bottom: 2.4rem;
  `}
`;

export const Content = styled.div`
  @media (max-width: 992px) {
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const TagsRow = styled.div`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.neutralSilver10};
    padding-bottom: 32px;
    margin-bottom: 40px;
    display: flex;
    gap: 14px;

    @media (max-width: 1200px) {
      margin-top: 32px;
    }

    @media (max-width: 992px) {
      display: none;
    }
  `}
`;

export const DealSection = styled.div`
  // margin-top: 32px;
  width: 100%;

  > div {
    width: 100%;
  }
`;

export const DealHeader = styled.div`
  margin-bottom: 16px;

  @media (max-width: 992px) {
    display: none;
  }
`;

export const OfferTitle = styled.p`
  ${({ theme }) => css`
    font-size: 1.6rem;
    font-weight: 500;
    color: ${theme.colors.brandPrimary70};
    margin: 0;
  `}
`;

export const IncreaseValueSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  margin-top: 48px;

  @media (max-width: 500px) {
    gap: 16px;

    svg[aria-label='dollar-icon'] {
      display: none;
    }
  }

  @media (max-width: 375px) {
    flex-direction: column;
    text-align: center;
  }
`;

export const IncreaseValueText = styled.p`
  ${({ theme }) => css`
    font-size: 1.2rem;
    color: ${theme.colors.neutralSilver70};
    line-height: 1.6;
    margin: 0;

    > strong {
      font-size: 1.6rem;
      font-weight: 500;
      color: ${theme.colors.neutralSilver90};

      @media (max-width: 500px) {
        font-size: 1.4rem;
      }
    }
  `}
`;

type BannerSectionProps = {
  visibility: boolean;
};

export const BannerSection = styled.div<BannerSectionProps>`
  ${({ visibility }) => css`
    display: ${visibility ? 'block' : 'none'};
    margin-bottom: 32px;
  `}
`;

export const WantCarContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const FormWantCar = styled(FormikForm)`
  display: inline-flex;
  flex-direction: column;
`;

export const WantCarNowSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
`;

export const EmailWrapper = styled.div`
  max-width: 332px;
  width: 100%;
  margin-top: 24px;
`;

export const Divider = styled.div`
  ${({ theme }) => css`
    font-size: 1.8rem;
    font-weight: 500;
    color: ${theme.colors.neutralSilver80};
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    position: relative;
    margin: 48px 0;

    > span {
      z-index: 1;
      padding: 0 40px;
      background-color: ${theme.colors.neutralSilver5};
      display: block;
    }

    &::before {
      content: '';
      position: absolute;
      height: 1px;
      width: 100%;
      background-color: ${theme.colors.neutralSilver30};
      left: 0;
    }

    @media (max-width: 768px) {
      margin: 24px 0;
    }
  `}
`;

export const OtherDeals = styled.div`
  display: flex;
  gap: 40px;

  @media (max-width: 600px) {
    gap: 24px;
    flex-direction: column;
    align-items: center;

    > button {
      max-width: 225px;
    }
  }
`;

export const OtherDealsText = styled.strong`
  ${({ theme }) => css`
    font-size: 2rem;
    font-weight: 600;
    color: ${theme.colors.neutralSilver90};
    line-height: 1.4;
    max-width: 260px;

    @media (max-width: 600px) {
      max-width: 100%;
      text-align: center;
    }
  `}
`;

export const MobileOnly = styled.div`
  @media (min-width: 992px) {
    display: none;
  }
`;

export const DesktopOnly = styled.div`
  @media (max-width: 992px) {
    display: none;
  }
`;

export const TermsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4px;

  @media (max-width: 400px) {
    flex-wrap: wrap;
    gap: 8px;
    justify-content: flex-start;
  }
`;

export const RadioLabel = styled.p`
  ${({ theme }) => css`
    font-weight: 500;
    font-size: 1.4rem;
    line-height: 2.2rem;
    color: ${theme.colors.neutralSilver70};

    margin-bottom: 8px;
  `}
`;

export const BannerDescriptionWrapper = styled.span`
  ${({ theme }) => css`
    strong {
      color: ${theme.colors.neutralSilver90};
    }

    a {
      font-weight: 500;
      font-size: 1.4rem;
      line-height: 2.2rem;
      color: ${theme.colors.neutralSilver70};
    }
  `}
`;

export const HeroTitleHighlight = styled.span`
  ${({ theme }) => css`
    color: ${theme.colors.brandSecondary80};
  `}
`;
